import React, { useEffect, useRef, useState } from "react";
import {
  Avatar,
  Col,
  Empty,
  Flex,
  Input,
  Row,
  Tag,
  theme,
  Tooltip,
} from "antd";
import "./Group.css";
import {
  faArrowRightFromBracket,
  faPlus,
  faUser,
  faUsersRectangle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch } from "react-redux";
import { setChatSpace } from "../../../Redux/ChatSpaceSlice";
import { setPopup } from "../../../Redux/PopupSlice";
const tagInputStyle = {
  width: 64,
  height: 22,
  marginInlineEnd: 8,
  verticalAlign: "top",
};
function Group() {
  const dispatch = useDispatch();
  const { token } = theme.useToken();
  const [tags, setTags] = useState([]);
  const [inputVisible, setInputVisible] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const inputRef = useRef(null);
  useEffect(() => {
    if (inputVisible) {
      inputRef.current?.focus();
    }
  }, [inputVisible === true]);
  const handleClose = (removedTag) => {
    const newTags = tags.filter((tag) => tag !== removedTag);
    console.log(newTags);
    setTags(newTags);
  };
  const showInput = () => {
    setInputVisible(true);
  };
  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };
  const handleInputOut = () => {
    setInputVisible(false);
  };
  const handleChooseConfirm = (title) => {
    if (title && !tags.includes(title)) {
      setTags([...tags, title]);
    }
    setInputVisible(true);
    setInputValue("");
    inputRef.current?.focus();
  };
  const removeNewestTag = () => {
    const newTags = tags.slice(0, tags.length - 1);
    setTags(newTags);
  };
  const tagPlusStyle = {
    height: 22,
    background: token.colorBgContainer,
    borderStyle: "dashed",
  };
  return (
    <>
      <div className="groupHeader">
        <Flex gap="4px 0" wrap>
          <Tooltip
            placement="left"
            color="whiteSmoke"
            overlayStyle={{ width: "150px" }}
            title={<GroupOption dispatch={dispatch} tags={tags} />}
          >
            <span className="groupHeaderTitle">Tạo nhóm: </span>
          </Tooltip>
          {tags.map((tag, index) => {
            const isLongTag = tag.length > 20;
            const tagElem = (
              <Tag
                key={tag}
                closable={index >= 0}
                style={{
                  userSelect: "none",
                }}
                onClose={() => handleClose(tag)}
              >
                <span>{isLongTag ? `${tag.slice(0, 20)}...` : tag}</span>
              </Tag>
            );
            return isLongTag ? (
              <Tooltip title={tag} key={tag}>
                {tagElem}
              </Tooltip>
            ) : (
              tagElem
            );
          })}
          {inputVisible ? (
            <Input
              ref={inputRef}
              type="text"
              size="small"
              style={tagInputStyle}
              value={inputValue}
              onChange={handleInputChange}
              onBlur={handleInputOut}
              // onPressEnter={handleInputOut}
              onKeyDown={(e) => {
                if (e.key === "Backspace" && inputValue === "") {
                  if (tags.length > 0) {
                    removeNewestTag();
                  }
                }
              }}
            />
          ) : (
            <Tag
              style={tagPlusStyle}
              icon={<FontAwesomeIcon icon={faPlus} />}
              onClick={showInput}
            >
              Thêm thành viên
            </Tag>
          )}
        </Flex>
      </div>
      <div className="groupBody">
        <Empty description="Hiện không tìm thấy người dùng" />
        {[...Array(10)].map((_, index) => (
          <Row
            onClick={() => handleChooseConfirm(`name of someone ${index}`)}
            className="groupUserResult"
          >
            <Col span={4} className="groupUserResultContent avatar">
              <Avatar icon={<FontAwesomeIcon icon={faUser} />} />
            </Col>
            <Col span={20} className="groupUserResultContent">
              <span>name of someone {index}</span>
            </Col>
          </Row>
        ))}
      </div>
    </>
  );
}

function GroupOption({ dispatch, tags }) {
  return (
    <Row className="groupHeaderOptionWrapper">
      <Col span={2} className="groupHeaderOption">
        <FontAwesomeIcon icon={faUsersRectangle} />
      </Col>
      <Col span={20} className="groupHeaderOption title">
        <span
          onClick={() => {
            if (tags.length < 2) {
              alert("Hãy thêm ít nhất 2 người dùng khác để tạo nhóm!");
              return;
            }
            dispatch(setChatSpace({ open: null, info: null }));
            dispatch(setPopup("message"));
          }}
          className="groupHeaderTitle option"
        >
          Tạo{" "}
        </span>
      </Col>
      <Col span={24}>
        <hr />
      </Col>
      <Col span={2} className="groupHeaderOption">
        <FontAwesomeIcon icon={faArrowRightFromBracket} />
      </Col>
      <Col span={20} className="groupHeaderOption title">
        <span
          onClick={() => dispatch(setChatSpace({ open: null, info: null }))}
          className="groupHeaderTitle option"
        >
          Thoát{" "}
        </span>
      </Col>
    </Row>
  );
}

export default Group;
